import PolygonBase from './PolygonBase';
import shapeIcon from '../assets/icons/shapeSubroutine.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.5;
const SIDEBAR_WIDTH = 1.0 / 15.0;

class ShapeSubroutine extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeIcon);
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    return `
      ${this.edgePathString()}

      M ${-0.5 + SIDEBAR_WIDTH} -0.5
      L ${-0.5 + SIDEBAR_WIDTH} 0.5

      M ${0.5 - SIDEBAR_WIDTH} -0.5
      L ${0.5 - SIDEBAR_WIDTH} 0.5
    `;
  }

  static edgePathString() {
    return `
      M -0.5 -0.5
      L 0.5 -0.5
      L 0.5 0.5
      L -0.5 0.5
      Z
    `;
  }

  calcTextMargin() {
    const { width } = this.fabricObject;
    const margins = super.calcTextMargin();
    margins.left += width * SIDEBAR_WIDTH * 1.25;
    margins.right += width * SIDEBAR_WIDTH * 1.25;
    return margins;
  }
}

export default ShapeSubroutine;
